var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover"},[_c('b-container',[_c('b-row',[_c('b-col',[_c('router-link',{attrs:{"to":"/gestion"}},[_c('div',{staticClass:"button humongous cover"})])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }